import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const TagStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  transition: ${VARIABLES.TRANSITIONS.DEFAULT};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: auto;
  min-height: 42px;
  border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
  color: ${VARIABLES.COLORS.BLUE_1};
  background-color: transparent;
  border: 1px solid ${VARIABLES.COLORS.GRAY_2};

  /* Child element styles
  ------------------------------- */
  .text {
    max-width: auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .image-control {
    &.remove-icon {
      height: 16px;
      margin-left: 12px;
      filter: brightness(0.8);
      transition: ${VARIABLES.TRANSITIONS.DEFAULT};
      cursor: pointer;

      .image {
        vertical-align: top;
        width: auto;
        height: 100%;
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */
  &.is-remove-hover {
    border-color: ${VARIABLES.COLORS.RED_1};

    .image-control {
      &.remove-icon {
        filter: none;
      }
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    padding: 7px;
    min-height: 40px;

    .image-control {
      &.remove-icon {
        height: 15px;
        margin-left: 11px;
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    padding: 6px;
    min-height: 38px;

    .image-control {
      &.remove-icon {
        height: 14px;
        margin-left: 10px;
      }
    }
  }

  @media all and (max-width: 1366.98px) {
    padding: 5px;
    min-height: 36px;

    .image-control {
      &.remove-icon {
        height: 13px;
        margin-left: 9px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    padding: 4px;
    min-height: 34px;

    .image-control {
      &.remove-icon {
        height: 12px;
        margin-left: 8px;
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    padding: 3px;
    min-height: 32px;

    .image-control {
      &.remove-icon {
        height: 11px;
        margin-left: 7px;
      }
    }
  }
`
